import { createListReducer } from 'app/redux/reducers/_reducer-factory/createListReducer';

const TEMPLATE_NAME = 'BRANCH';

export default createListReducer(TEMPLATE_NAME);
